import React, { Component } from "react";

import { Empty } from "../components/loaders";

class ClientDashboardNotifications extends Component {
  render() {
    return (
      <div>
        <Empty message="No hay notificaciones" />
      </div>
    );
  }
}

export default ClientDashboardNotifications;
